import Image from 'next/image';
import Icon from './help_red.svg?url';
import type { SvgImageProps } from '../_type';

export const HelpRedImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={Icon} alt={alt} {...props} />
);
